import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["sx"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Card, cardClasses, css, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var ResizableCardInner = styled(Card, {
  shouldForwardProp: isPropValid
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  box-shadow: ", ";\n  transition: all 0.5s ease;\n  bottom: 0;\n\n  ", "\n"])), function (p) {
  return p.theme.shadows[1];
}, function (_ref) {
  var withWiggle = _ref.withWiggle;
  return withWiggle && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      animation: wiggle 3s;\n      animation-iteration-count: infinite;\n\n      @keyframes wiggle {\n        0% {\n          transform: rotate(-0.5deg);\n        }\n        8% {\n          transform: rotate(0.5deg);\n        }\n        16% {\n          transform: rotate(-0.5deg);\n        }\n        24% {\n          transform: rotate(0.5deg);\n        }\n        33% {\n          transform: rotate(0deg);\n        }\n      }\n    "])));
});
export var ResizableCard = function ResizableCard(_ref2) {
  var sx = _ref2.sx,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(Box, {
    sx: mergeSxProps(_defineProperty({
      minWidth: 228
    }, "&:hover > .".concat(cardClasses.root), {
      bottom: function bottom(t) {
        return t.spacing(0.5);
      },
      boxShadow: function boxShadow(t) {
        return t.shadows[4];
      }
    }), sx),
    "data-element": "Box",
    "data-component": "ResizableCard",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(ResizableCardInner, _objectSpread(_objectSpread({}, props), {}, {
      "data-element": "ResizableCardInner",
      "data-component": "ResizableCard",
      "data-source-file": "index.tsx"
    }))
  });
};